import React from 'react';
import TopNavbar from '../home/TopNavbar';

const styles = `
    .container {
        max-width: 1200px;
        margin: auto;
        background-color: #fff;
        padding: 10px;
        border-radius: 10px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        padding-bottom: 100px;
        margin-top: 30px;
    }

    /* Scrollable Wrapper */
    .table-wrapper {
        width: 100%;
        overflow-x: auto; /* Enables horizontal scroll */
        -webkit-overflow-scrolling: touch;
        margin-top: 20px;
        border-radius: 8px;
    }

    /* Heading styles */
    .main-heading {
        padding-top: 50px;
        color: #004d40;
        text-align: center;
        font-size: 1.5em;
        margin-bottom: 10px;
        border-bottom: 3px solid #004d40;
        padding-bottom: 10px;
    }

    .sub-heading {
        color: #00695c;
        font-size: 2em;
        margin-top: 40px;
        margin-bottom: 15px;
    }

    /* Paragraph styles */
    .intro-paragraph, .section-paragraph {
        font-size: 1em;
        text-align: justify;
        margin-bottom: 20px;
    }

    /* Table styles */
    table {
        width: 100%;
        min-width: 800px; /* Ensures the table doesn't compress too much */
        border-collapse: collapse;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    th, td {
        padding: 12px;
        text-align: left;
        border: 1px solid #ddd;
    }

    thead th {
        background-color: #004d40;
        color: #fff;
        font-weight: bold;
        text-transform: uppercase;
    }

    /* Alternating row colors */
    tbody tr:nth-child(even) {
        background-color: #e8f5e9;
    }

    tbody tr:nth-child(odd) {
        background-color: #f0fdf2;
    }

    /* Hover effect */
    tbody tr:hover {
        background-color: #c8e6c9;
        transition: background-color 0.3s ease;
    }

    /* Styling for the total row */
    tbody tr:last-child {
        font-weight: bold;
        background-color: #b2dfdb !important;
    }

    tbody tr:last-child td {
        border-top: 2px solid #004d40;
    }

    /* Custom Scrollbar for better UX */
    .table-wrapper::-webkit-scrollbar {
        height: 6px;
    }
    .table-wrapper::-webkit-scrollbar-thumb {
        background: #004d40;
        border-radius: 10px;
    }
    .table-wrapper::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
`;

const ChemistryData = [
    { chapter: "Alcohols, Phenols and Ethers", easy: 1, medium: 6, hard: 0, total: 7, average: 1.40, weightage: '2.66%' },
    { chapter: "Aldehydes, Ketones and Carboxylic Acids", easy: 1, medium: 9, hard: 9, total: 19, average: 3.80, weightage: '7.22%' },
    { chapter: "Amines", easy: 1, medium: 7, hard: 2, total: 10, average: 2.00, weightage: '3.80%' },
    { chapter: "Biomolecules", easy: 3, medium: 4, hard: 1, total: 8, average: 1.60, weightage: '3.04%' },
    { chapter: "Chemical Bonding and Molecular Structure", easy: 2, medium: 6, hard: 5, total: 13, average: 2.60, weightage: '4.94%' },
    { chapter: "Chemical Kinetics", easy: 4, medium: 2, hard: 5, total: 11, average: 2.20, weightage: '4.18%' },
    { chapter: "Classification of Elements and Periodicity in Properties", easy: 3, medium: 1, hard: 1, total: 5, average: 1.00, weightage: '1.90%' },
    { chapter: "Coordination Compounds", easy: 2, medium: 5, hard: 4, total: 11, average: 2.20, weightage: '4.18%' },
    { chapter: "Electrochemistry", easy: 2, medium: 3, hard: 5, total: 10, average: 2.00, weightage: '3.80%' },
    { chapter: "Environmental Chemistry", easy: 2, medium: 1, hard: 0, total: 3, average: 0.60, weightage: '1.14%' },
    { chapter: "Equilibrium", easy: 3, medium: 6, hard: 2, total: 11, average: 2.20, weightage: '4.18%' },
    { chapter: "General Principles and Processes of Isolation of Elements", easy: 2, medium: 5, hard: 0, total: 7, average: 1.40, weightage: '2.66%' },
    { chapter: "Haloalkanes and Haloarenes", easy: 5, medium: 3, hard: 0, total: 8, average: 1.60, weightage: '3.04%' },
    { chapter: "Hydrocarbons", easy: 1, medium: 9, hard: 3, total: 13, average: 2.60, weightage: '4.94%' },
    { chapter: "Hydrogen", easy: 0, medium: 4, hard: 0, total: 4, average: 0.80, weightage: '1.52%' },
    { chapter: "Organic Chemistry: Some Basic Principles and Techniques", easy: 4, medium: 6, hard: 2, total: 12, average: 2.40, weightage: '4.56%' },
    { chapter: "Polymers", easy: 1, medium: 2, hard: 1, total: 4, average: 0.80, weightage: '1.52%' },
    { chapter: "Redox Reactions", easy: 1, medium: 3, hard: 1, total: 5, average: 1.00, weightage: '1.90%' },
    { chapter: "Solutions", easy: 1, medium: 3, hard: 3, total: 7, average: 1.40, weightage: '2.66%' },
    { chapter: "Some Basic Concepts of Chemistry", easy: 1, medium: 4, hard: 5, total: 10, average: 2.00, weightage: '3.80%' },
    { chapter: "States of Matter", easy: 2, medium: 4, hard: 1, total: 7, average: 1.40, weightage: '2.66%' },
    { chapter: "Structure of Atom", easy: 2, medium: 3, hard: 3, total: 8, average: 1.60, weightage: '3.04%' },
    { chapter: "Surface Chemistry", easy: 1, medium: 3, hard: 1, total: 5, average: 1.00, weightage: '1.90%' },
    { chapter: "The d and f-Block Elements", easy: 2, medium: 12, hard: 2, total: 16, average: 3.20, weightage: '6.08%' },
    { chapter: "The p-Block Elements", easy: 2, medium: 7, hard: 0, total: 9, average: 1.80, weightage: '3.42%' },
    { chapter: "The p-Block Elements (XII)", easy: 4, medium: 4, hard: 1, total: 9, average: 1.80, weightage: '3.42%' },
    { chapter: "The s-Block Elements", easy: 4, medium: 4, hard: 2, total: 10, average: 2.00, weightage: '3.80%' },
    { chapter: "The Solid State", easy: 2, medium: 2, hard: 3, total: 7, average: 1.40, weightage: '2.66%' },
    { chapter: "Thermodynamics", easy: 2, medium: 6, hard: 2, total: 10, average: 2.00, weightage: '3.80%' },
    { chapter: "Chemistry in Everyday Life", easy: 1, medium: 1, hard: 1, total: 3, average: 0.60, weightage: '1.14%' },
    { chapter: "Principles of Qualitative Analysis", easy: 0, medium: 1, hard: 0, total: 1, average: 0.20, weightage: '0.38%' },
];

const renderTable = (data) => (
    <div className="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th>Chapter Name</th>
                    <th>Easy</th>
                    <th>Medium</th>
                    <th>Hard</th>
                    <th>Total</th>
                    <th>Average Q/yr</th>
                    <th>Weightage</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index}>
                        <td>{item.chapter}</td>
                        <td>{item.easy}</td>
                        <td>{item.medium}</td>
                        <td>{item.hard}</td>
                        <td>{item.total}</td>
                        <td>{item.average}</td>
                        <td>{item.weightage}</td>
                    </tr>
                ))}
                <tr>
                    <td><strong>Total</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.easy, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.medium, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.hard, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.total, 0)}</strong></td>
                    <td><strong>{data.reduce((sum, item) => sum + item.average, 0).toFixed(2)}</strong></td>
                    <td><strong>100%</strong></td>
                </tr>
            </tbody>
        </table>
    </div>
);

const NeetWeightageChemistry = () => {
    return (
        <div>
            <style>{styles}</style>
            <div className="container">
                <TopNavbar name="Chemistry Weightage" />
                <h1 className="main-heading">NEET 5-Year Chemistry Question Analysis (2020-2024)</h1>
                <p className="intro-paragraph">
                    The Chemistry section analysis from 2020 to 2024 shows a consistent distribution of easy, medium, and hard questions. This breakdown provides insights into average weightage and helps aspirants focus on key topics.
                </p>
                {renderTable(ChemistryData)}
            </div>
        </div>
    );
};

export default NeetWeightageChemistry;